// Others
import axiosClient from './axiosClient';
import { urlApiFolder } from '~/utils/constants/apis';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IEditFolder, IFolder, IFolderParams, IFormFolder } from '~/utils/interface/folder';

const folderApi = {
  getFolderList: (params: IFolderParams) => {
    const url = urlApiFolder.getFolderList;
    return axiosClient.get<IBaseResponse<IListDataResponse<IFolder[]>>>(url, { params });
  },

  createFolder: (body: IFormFolder) => {
    const url = urlApiFolder.createFolder;
    return axiosClient.post<IBaseResponse>(url, body);
  },

  editFolder: (payload: IEditFolder) => {
    const { folderId, body } = payload;
    const url = urlApiFolder.editFolder(folderId);
    return axiosClient.put<IBaseResponse>(url, body);
  },

  deleteFolder: (folderId: string) => {
    const url = urlApiFolder.deleteFolder(folderId);
    return axiosClient.delete<IBaseResponse>(url);
  },
};

export default folderApi;
